/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiComponentBlockCategory;
(function (ApiComponentBlockCategory) {
    ApiComponentBlockCategory["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    ApiComponentBlockCategory["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    ApiComponentBlockCategory["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    ApiComponentBlockCategory["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    ApiComponentBlockCategory["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    ApiComponentBlockCategory["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    ApiComponentBlockCategory["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    ApiComponentBlockCategory["CTAS"] = "ComponentBlockCategory_CTAs";
    ApiComponentBlockCategory["FAQS"] = "ComponentBlockCategory_FAQs";
})(ApiComponentBlockCategory || (ApiComponentBlockCategory = {}));
export function ApiComponentBlockCategoryFromJSON(json) {
    return ApiComponentBlockCategoryFromJSONTyped(json, false);
}
export function ApiComponentBlockCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiComponentBlockCategoryToJSON(value) {
    return value;
}
